"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

var _gripVerticalSolidWhiteDataUrl = _interopRequireDefault(require("../../icons/gripVerticalSolidWhiteDataUrl"));

var _button = _interopRequireDefault(require("./button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var amChartScrollbar = function amChartScrollbar(scrollbar) {
  var create = function create(id) {
    var amScrollbar = new am4core.Scrollbar();
    amScrollbar.id = id;
    return amScrollbar;
  };

  var setGripDefaultStyles = function setGripDefaultStyles(grip, theme) {
    (0, _button["default"])(grip).setDefaultStyles(theme);
    var gripImage = grip.createChild(am4core.Image);
    gripImage.href = _gripVerticalSolidWhiteDataUrl["default"];
    grip.icon = gripImage;
    gripImage.width = 14;
    gripImage.height = 14;
    gripImage.align = 'center';
    gripImage.valign = 'middle';
    gripImage.horizontalCenter = 'middle';
    gripImage.verticalCenter = 'middle';
    grip.padding(theme.space[1], theme.space[1], theme.space[1], theme.space[1]);
    grip.width = theme.sizes[2];
    grip.height = theme.sizes[2];
    return grip;
  };

  var setDefaultStyles = function setDefaultStyles(theme) {
    setGripDefaultStyles(scrollbar.startGrip, theme);
    setGripDefaultStyles(scrollbar.endGrip, theme);
    scrollbar.background.fill = am4core.color(theme.colors.neutral[1]);
    scrollbar.background.fillOpacity = 1;
    scrollbar.thumb.background.fill = am4core.color(theme.colors.primaryLight);
    scrollbar.thumb.background.strokeWidth = 0;
    scrollbar.background.paddingTop = 2;
    scrollbar.background.paddingBottom = 2;
    scrollbar.thumb.background.paddingTop = 2;
    scrollbar.thumb.background.paddingBottom = 2;
    var thumbHoverStyles = scrollbar.thumb.background.states.getKey('hover');
    thumbHoverStyles.properties.fill = am4core.color(theme.colors.primary);
    scrollbar.thumb.background.states.getKey('down').properties.fill = am4core.color(theme.colors.primaryLight);
    return scrollbar;
  };

  return {
    create: create,
    setDefaultStyles: setDefaultStyles
  };
};

var _default = amChartScrollbar;
exports["default"] = _default;